var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPowerfulAnalysisToolsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 26C23.1046 26 24 25.1046 24 24C24 22.8954 23.1046 22 22 22C20.8954 22 20 22.8954 20 24C20 25.1046 20.8954 26 22 26Z",
    fill: "url(#paint0_linear_1277_476)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7769 23.4785C29.159 21.9045 28.0927 20.5464 26.7103 19.5726C25.3279 18.5987 23.6902 18.052 22 18C20.3098 18.052 18.6721 18.5987 17.2897 19.5726C15.9073 20.5464 14.841 21.9045 14.2231 23.4785L14 24L14.2231 24.5215C14.841 26.0955 15.9073 27.4536 17.2897 28.4274C18.6721 29.4013 20.3098 29.948 22 30C23.6902 29.948 25.3279 29.4013 26.7103 28.4274C28.0927 27.4536 29.159 26.0955 29.7769 24.5215L30 24L29.7769 23.4785ZM22 28C21.2089 28 20.4355 27.7654 19.7777 27.3259C19.1199 26.8864 18.6072 26.2616 18.3045 25.5307C18.0017 24.7998 17.9225 23.9956 18.0769 23.2196C18.2312 22.4437 18.6122 21.731 19.1716 21.1716C19.731 20.6122 20.4437 20.2312 21.2196 20.0769C21.9956 19.9225 22.7998 20.0017 23.5307 20.3045C24.2616 20.6072 24.8864 21.1199 25.3259 21.7777C25.7654 22.4355 26 23.2089 26 24C25.9988 25.0605 25.577 26.0772 24.8271 26.8271C24.0772 27.577 23.0605 27.9988 22 28Z",
    fill: "url(#paint1_linear_1277_476)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17H7V19H12V17Z",
    fill: "url(#paint2_linear_1277_476)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12H7V14H19V12Z",
    fill: "url(#paint3_linear_1277_476)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 7H7V9H19V7Z",
    fill: "url(#paint4_linear_1277_476)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 2H4C3.47004 2.00153 2.96222 2.21274 2.58748 2.58748C2.21274 2.96222 2.00153 3.47004 2 4V28C2.00153 28.53 2.21274 29.0378 2.58748 29.4125C2.96222 29.7873 3.47004 29.9985 4 30H12V28H4V4H22V15H24V4C23.9985 3.47004 23.7873 2.96222 23.4125 2.58748C23.0378 2.21274 22.53 2.00153 22 2Z",
    fill: "url(#paint5_linear_1277_476)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1277_476",
    x1: 30.0202,
    y1: 16,
    x2: 2,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D1775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1383F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1277_476",
    x1: 30.0202,
    y1: 16,
    x2: 2,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D1775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1383F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1277_476",
    x1: 30.0202,
    y1: 16,
    x2: 2,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D1775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1383F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1277_476",
    x1: 30.0202,
    y1: 16,
    x2: 2,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D1775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1383F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1277_476",
    x1: 30.0202,
    y1: 16,
    x2: 2,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D1775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1383F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1277_476",
    x1: 30.0202,
    y1: 16,
    x2: 2,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D1775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1383F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerfulAnalysisToolsIcon);
export default __webpack_public_path__ + "static/media/powerfulAnalysisToolsIcon.02e66134326b665965376e91bb5cc447.svg";
export { ForwardRef as ReactComponent };